import { Address, rpcSchema } from 'viem'

export type UsingBigBlocksRpcSchema = [
  {
    Method: 'eth_usingBigBlocks'
    Parameters: [Address]
    ReturnType: boolean
  },
]

export const usingBigBlocksRpcSchema = rpcSchema<UsingBigBlocksRpcSchema>()
